// file contains links we need from the landing page
export enum Links {
  CREATE_MEETING = '/create',
}
